/**
 * rankingPhotoCard.tsx
 */
import Card from '@shared/types/props/card';
import Event from '@shared/classes/event';
import HorizontalCard from './horizontalCard';
import RankingContainer from '@components/atoms/container/rankingPositionContainer';
import { memo } from 'react';

/**
 * Ranking photo card component.
 */
function RankingPhotoCard(props: Card) {
  const item = props.item as Event;
  return (
    <div style={{ display: props.hide ? 'none' : 'flex' }}>
      <RankingContainer position={item?.position} hide={props.hide}>
        {item?.position !== undefined ? `${item?.position}` : ''}
      </RankingContainer>
      <HorizontalCard {...props}></HorizontalCard>
    </div>
  );
}

export default memo(RankingPhotoCard);
